import { render, staticRenderFns } from "./ContMyReportsGDS.vue?vue&type=template&id=478653c4&scoped=true&lang=pug"
import script from "./ContMyReportsGDS.vue?vue&type=script&lang=js"
export * from "./ContMyReportsGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478653c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('478653c4')) {
      api.createRecord('478653c4', component.options)
    } else {
      api.reload('478653c4', component.options)
    }
    module.hot.accept("./ContMyReportsGDS.vue?vue&type=template&id=478653c4&scoped=true&lang=pug", function () {
      api.rerender('478653c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refactoring/ContMyReportsGDS.vue"
export default component.exports